
import PropTypes from "prop-types";
import { useEffect } from "react";
import { Box, Typography, TextField, Card, CardContent } from "@mui/material";

import { useUtils } from "../../context/UtilsProvider";
import { useClient } from "../../context/ClientProvider";

import environment from "../../env";


function ArrangementBankTransfer({ account, setConsent }) {

  const { capitaliseWords } = useUtils();
  const { clientSortCode, clientAccountNumber } = useClient();

  useEffect(() => {
    // Enable confirm button by default
    setConsent(true);
  }, []);

  return account && (
    <Card
      sx={{
        borderRadius: { xs: 0, md: 0 },
        pb: 2,
      }}
    >
      <Box>
        {/* Bank transfer account details */}
        <CardContent>
          <Typography sx={{ fontSize: 18, fontWeight: "bold", mb: 2 }}>
            Bank transfer details
          </Typography>
          <Typography>
            {`Please use the bank account details provided below once your repayment plan has
              been confirmed, ensuring that reference is populated with your ${capitaliseWords(environment?.CLIENT_NAME)} 
              reference number `}
            <Typography
              variant='span'
              color='black'
              fontWeight='bold'
            >
              {account?.accountReference}.
            </Typography>
          </Typography>
          <Box
            id="bankTransferSortCode"
            sx={{ mt: 2 }}            
          >
            <Typography
              component='label'
              htmlFor='sortCode'
              fontWeight={"bold"}
            >
              Sort code
            </Typography>
            <Box>
              <TextField
                disabled
                margin='dense'
                required
                id='sortCode'
                name='sortCode'
                value={clientSortCode}
                sx={{
                  backgroundColor: "lightgrey",
                  width: { xs: "100%", md: "40%" }
                }}
              />
            </Box>
          </Box>
          <Box
            id="bankTransferAccountNumber"
            sx={{ mt: 2 }}                          
          >
            <Typography
              component='label'
              htmlFor='accountNumber'
              fontWeight={"bold"}
              sx={{ mt: 1 }}
            >
              Account number
            </Typography>
            <Box>
              <TextField
                disabled
                margin='dense'
                required
                id='accountNumber'
                name='accountNumber'
                value={clientAccountNumber}
                sx={{
                  mb: 5,
                  backgroundColor: "lightgrey",
                  width: { xs: "100%", md: "40%" }
                }}
              />
            </Box>
          </Box>
        </CardContent>
        {/* End of bank transfer account details */}
      </Box>
    </Card>
  );
};

ArrangementBankTransfer.propTypes = {
  account: PropTypes.object.isRequired,
  setConsent: PropTypes.func.isRequired,
};

export default ArrangementBankTransfer;